import { render, staticRenderFns } from "./OrderProductTable.vue?vue&type=template&id=3253a460&scoped=true&"
import script from "./OrderProductTable.vue?vue&type=script&lang=js&"
export * from "./OrderProductTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductTable.vue?vue&type=style&index=0&id=3253a460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253a460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDataTable,VSimpleCheckbox})
